<template>
  <div class="flex gap-1">
    <AnchorIcon class="mt-1.5 size-4" />
    <template v-if="paragraph?.legal_text">
      <ParagraphLink
        class="link text-6pt"
        :legalText="paragraph.legal_text.slug"
        :legalTextParagraph="paragraph.slug"
        :title="title"
        :legalTextParagraphId="paragraph.id"
        :oldVersionId="oldVersionId"
        :withPreview="true"
      >
        {{ title }}
      </ParagraphLink>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";

interface Props {
  paragraph: ILegalTextParagraph;
}

const props = defineProps<Props>();

const { title } = useFullParagraphTitle(() => props.paragraph, true);
const { oldVersionId } = useParagraphOldVersionId(() => props.paragraph);
</script>
